module.exports = __webpack_public_path__ + "ebdf65959d4749d0db3f7fb9338acfc6.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/museo_slab_500-webfont.woff2
// module id = XjdD
// module chunks = 0